import { APP_INITIALIZER, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

import { ServiceWorkerModule } from '@angular/service-worker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './core-component/app.component';
import { AppRoutingModule } from './routing/app-routing.module';
import { SharedModule } from './modules/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { AngularFireModule } from '@angular/fire/compat';

import { TopNavComponent } from './components/top-nav/top-nav.component';
import { EmployeeProfileComponent } from './components/employee-profile/employee-profile.component';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { AppAuthGuard } from './modules/shared/services/auth-guard/auth-guard.service';
import { HasroleDirective } from './modules/shared/directives/has-role.directive';
import { ErrorComponent } from './components/error/error.component';
import { NotificationComponent } from './components/notification/notification.component';
import { environment } from 'src/environments/environment';
import { ShowVersionComponent } from './components/show-version/show-version.component';
import { SessionExpiredDialogComponent } from './components/session-expired-dialog/session-expired-dialog.component';
import { MSAL_INSTANCE, MsalService } from '@azure/msal-angular';
import { MSALInstanceFactory, initializeMsal } from './modules/shared/utils/initializeMicrosoftLogin';
import { AuthService } from './modules/shared/services/auth-service/auth.service';

@NgModule({
  declarations: [
    AppComponent,
    TopNavComponent,
    EmployeeProfileComponent,
    HasroleDirective,
    ErrorComponent,
    NotificationComponent,
    ShowVersionComponent,
    SessionExpiredDialogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    SharedModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    BrowserAnimationsModule,
    FormsModule,
    MomentDateModule,
    CommonModule,
  ],
  providers: [AppAuthGuard,
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    MsalService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMsal,
      deps: [AuthService, MsalService],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
